import { Expose } from "class-transformer";
import { IsNumber, IsString, IsBoolean, IsOptional } from "class-validator";

export class ServiceType {
  @IsOptional()
  @IsNumber()
  @Expose()
  id!: number | null;
  @IsString()
  @Expose()
  name!: string;
  @IsOptional()
  @IsString()
  @Expose()
  code!: string | null;
  @IsString()
  @Expose()
  vat!: string;
  @IsBoolean()
  @Expose()
  isLocked!: boolean;
}
